import {IPageObj, ISubPageObj} from './page';
import {NavigationPageEnum, NavigationTabEnum} from '../../../features/user-access/models/navigations.enums';
import {IconsEnum} from '../../../shared-modules/shared-icons/models/icons.enum';

/**
 * Quotes redesign gate.
 * When `false`: Quotes is hidden from the side nav and `/quotes` routes are blocked for everyone.
 * When `true`: Quotes behaves as a normal accessible feature again.
 */
export const ENABLE_QUOTES_FEATURE = false;

/**
 * Product Mapping gate.
 * When `false`: Product Mapping is hidden from the side nav and `/stock-match` routes are blocked for everyone.
 * When `true`: Product Mapping behaves as a normal accessible feature again.
 */
export const ENABLE_PRODUCT_MAPPING_FEATURE = false;

//#region FEATURE - AUTO ORDERING
export const FEATURE_AUTO_ORDERING_PAGE: IPageObj = {
  page: NavigationPageEnum.AutoOrdering,
  text: 'Auto Ordering',
  icon: IconsEnum.cart,
  multiple: true,
  tab: NavigationTabEnum.Orders,
};
//#endregion

/**
 * TODO Rename to FEATURE_**
 */
//#region FEATURE - BARCODE SCANNER
export const BARCODE_SCANNER_PAGE_HOME: IPageObj = {
  page: NavigationPageEnum.BarcodeScannerPageHome,
  text: 'Barcode Scanner',
  icon: IconsEnum.barcodeScan,
};

export const BARCODE_SCANNER_PAGE_BIN_LOCATIONS_UPDATE: IPageObj = {
  page: NavigationPageEnum.BarcodeScannerPageBinLocationsUpdate,
  text: 'Update Bin Location',
  icon: IconsEnum.archiveMarkerOutline,
};

export const BARCODE_SCANNER_PAGE_ORDER_CREATE: IPageObj = {
  page: NavigationPageEnum.BarcodeScannerPageOrderCreate,
  text: 'Create Orders',
  icon: IconsEnum.cartOutline,
};

export const BARCODE_SCANNER_PAGE_GRV_PROCESS: IPageObj = {
  page: NavigationPageEnum.BarcodeScannerPageProcessGRV,
  text: 'Process GRV',
  icon: IconsEnum.receiptTextOutline,
};

export const BARCODE_SCANNER_PAGE_SHELF_TALKERS_PRINT: IPageObj = {
  page: NavigationPageEnum.BarcodeScannerPageShelfTalkersPrint,
  text: 'Print Shelf Talkers',
  icon: IconsEnum.tagMultipleOutline,
};

export const BARCODE_SCANNER_PAGE_STOCK_UPDATE: IPageObj = {
  page: NavigationPageEnum.BarcodeScannerPageStockUpdate,
  text: 'Update Stock',
  icon: IconsEnum.create,
};

export const BARCODE_SCANNER_PAGES: IPageObj[] = [
  // BARCODE_SCANNER_PAGE_HOME,
  BARCODE_SCANNER_PAGE_BIN_LOCATIONS_UPDATE,
  BARCODE_SCANNER_PAGE_ORDER_CREATE,
  BARCODE_SCANNER_PAGE_GRV_PROCESS,
  BARCODE_SCANNER_PAGE_SHELF_TALKERS_PRINT,
  BARCODE_SCANNER_PAGE_STOCK_UPDATE,
];
//#endregion

//#region FEATURE - HOME
export const FEATURE_HOME_PAGE: IPageObj = {
  page: NavigationPageEnum.Home,
  text: 'Home',
  icon: IconsEnum.home,
};
//#endregion

//#region FEATURE - DASHBOARD
export const FEATURE_DASHBOARD_PAGE: IPageObj = {
  page: NavigationPageEnum.Dashboard,
  text: 'Dashboard',
  icon: IconsEnum.pieChart,
};
//#endregion

//#region FEATURE - DASHBOARD REPORTING
export const FEATURE_DASHBOARD_REPORTING_PAGE: IPageObj = {
  page: NavigationPageEnum.DashboardReporting,
  text: 'Dashboard Reporting',
  icon: IconsEnum.fileTrayStacked,
};
//#endregion

//#region FEATURE - LOGIN
export const FEATURE_LOGIN_PAGE: IPageObj = {
  page: NavigationPageEnum.Login,
  text: 'Sign In',
  icon: IconsEnum.logIn,
};
//#endregion

//#region FEATURE - NGP REPORT
export const FEATURE_NGP_REPORT_PAGE: IPageObj = {
  page: NavigationPageEnum.NGPReport,
  text: 'NGP Report',
  icon: IconsEnum.clipboard,
};
//#endregion

//#region FEATURE - QUOTES
export const FEATURE_QUOTES_PAGE: IPageObj = {
  page: NavigationPageEnum.Quotes,
  text: 'Quotes',
  icon: IconsEnum.calculator,
};
//#endregion

//#region FEATURE - SETTINGS

export const FEATURE_SETTINGS_LAYOUT_PAGE: IPageObj = {
  page: NavigationPageEnum.SettingsNew,
  text: 'Settings',
  icon: IconsEnum.settings,
};
//#endregion

//#region FEATURE - SHELF TALKERS
export const FEATURE_SHELF_TALKERS_PAGE: IPageObj = {
  page: NavigationPageEnum.ShelfTalkers,
  text: 'Shelf Talkers',
  icon: IconsEnum.priceTags,
};
//#endregion

//#region FEATURE - STAFF ACCESS
export const FEATURE_STAFF_ACCESS_PAGE: IPageObj = {
  page: NavigationPageEnum.UserAccess,
  text: 'Staff Access',
  icon: IconsEnum.key,
};
//#endregion

//#region FEATURE - STOCK TAKE
export const FEATURE_STOCK_TAKE_PAGE: IPageObj = {
  page: NavigationPageEnum.StockTake,
  text: 'Stock Taking',
  icon: IconsEnum.clipboardCheckOutline,
  multiple: true,
  tab: NavigationTabEnum.StockTakeDashboard,
};

export const FEATURE_STOCK_TAKE_MOBILE_PAGE: IPageObj = {
  page: NavigationPageEnum.StockTake,
  text: 'Stock Take',
  icon: IconsEnum.clipboardCheckOutline,
  multiple: false,
  tab: NavigationTabEnum.StockTakeList,
};

export const SUB_FEATURE_STOCK_TAKE_DASHBOARD: IPageObj = {
  icon: IconsEnum.pieChart,
  page: NavigationPageEnum.StockTake,
  tab: NavigationTabEnum.StockTakeDashboard,
  text: 'Dashboard',
};

export const SUB_FEATURE_STOCK_TAKE_LIST: IPageObj = {
  icon: IconsEnum.clipboardCheckOutline,
  page: NavigationPageEnum.StockTake,
  tab: NavigationTabEnum.StockTakeList,
  text: 'Stock Take',
};

export const SUB_FEATURE_STOCK_TAKE_SCHEDULE: IPageObj = {
  icon: IconsEnum.calendar,
  page: NavigationPageEnum.StockTake,
  tab: NavigationTabEnum.StockTakeSchedule,
  text: 'Schedule',
};
//#endregion

//#region FEATURE - STOCK MANAGER
export const FEATURE_STOCK_MANAGER_PAGE: IPageObj = {
  page: NavigationPageEnum.StockManager,
  text: 'Stock Manager',
  icon: IconsEnum.create,
  multiple: true,
  tab: NavigationTabEnum.StockManagerStock,
};

export const SUB_FEATURE_STOCK_MANAGER_STOCK: IPageObj = {
  icon: IconsEnum.store,
  page: NavigationPageEnum.StockManager,
  tab: NavigationTabEnum.StockManagerStock,
  text: 'Single-Store',
};

export const SUB_FEATURE_STOCK_MANAGER_MULTI_STORE: IPageObj = {
  icon: IconsEnum.storeMultiple,
  page: NavigationPageEnum.StockManager,
  tab: NavigationTabEnum.StockManagerMultiStore,
  text: 'Multi-Store',
};

export const FEATURE_STOCK_MANAGER_MOBILE_PAGE: IPageObj = {
  page: NavigationPageEnum.StockManager,
  text: 'Stock Lookup',
  icon: IconsEnum.create,
  tab: NavigationTabEnum.StockManagerStock,
};
//#endregion

//#region FEATURE - PRODUCT MAPPING
export const FEATURE_PRODUCT_MAPPING_PAGE: IPageObj = {
  page: NavigationPageEnum.ProductMapping,
  text: 'Product Mapping',
  icon: IconsEnum.linkVariant,
};
//#endregion

//#region SUB FEATURE - AUTO ORDERING
export const SUB_FEATURE_AUTO_EDIT_SCHEDULE: IPageObj = {
  icon: IconsEnum.calendar,
  page: NavigationPageEnum.AutoOrdering,
  tab: NavigationTabEnum.Schedule,
  text: 'Edit Schedule',
};

export const SUB_FEATURE_AUTO_UNSCHEDULED: IPageObj = {
  icon: IconsEnum.calendarClear,
  page: NavigationPageEnum.AutoOrdering,
  tab: NavigationTabEnum.Unscheduled,
  text: 'Unscheduled',
};

export const SUB_FEATURE_AUTO_ORDER_ORDERS: IPageObj = {
  icon: IconsEnum.today,
  page: NavigationPageEnum.AutoOrdering,
  tab: NavigationTabEnum.Orders,
  text: 'Orders',
};

//#endregion


//#region PAGES - DESKTOP VIEW
export const DESKTOP_PAGES: IPageObj[] = [
  FEATURE_HOME_PAGE,
  FEATURE_DASHBOARD_PAGE,
  FEATURE_DASHBOARD_REPORTING_PAGE,
  FEATURE_LOGIN_PAGE,
  FEATURE_STOCK_MANAGER_PAGE,
  ...(ENABLE_PRODUCT_MAPPING_FEATURE ? [FEATURE_PRODUCT_MAPPING_PAGE] : []),
  ...(ENABLE_QUOTES_FEATURE ? [FEATURE_QUOTES_PAGE] : []),
  FEATURE_NGP_REPORT_PAGE,
  FEATURE_STOCK_TAKE_PAGE,
  FEATURE_AUTO_ORDERING_PAGE,
  FEATURE_SHELF_TALKERS_PAGE,
  FEATURE_STAFF_ACCESS_PAGE,
  FEATURE_SETTINGS_LAYOUT_PAGE
];
//#endregion

//#region PAGES - MOBILE VIEW
export const MOBILE_PAGES: IPageObj[] = [
  FEATURE_HOME_PAGE,
  FEATURE_DASHBOARD_PAGE,
  FEATURE_STOCK_MANAGER_MOBILE_PAGE,
  ...(ENABLE_PRODUCT_MAPPING_FEATURE ? [FEATURE_PRODUCT_MAPPING_PAGE] : []),
  ...(ENABLE_QUOTES_FEATURE ? [FEATURE_QUOTES_PAGE] : []),
  FEATURE_STOCK_TAKE_MOBILE_PAGE,
  BARCODE_SCANNER_PAGE_HOME,
];
//#endregion

//#region SUB PAGES - ALL
export const PAGES_SUB: ISubPageObj = {
  ['auto-ordering']: [
    SUB_FEATURE_AUTO_ORDER_ORDERS,
    SUB_FEATURE_AUTO_EDIT_SCHEDULE,
    SUB_FEATURE_AUTO_UNSCHEDULED,
  ],
  ['stock-take']: [
    SUB_FEATURE_STOCK_TAKE_DASHBOARD,
    SUB_FEATURE_STOCK_TAKE_LIST,
    SUB_FEATURE_STOCK_TAKE_SCHEDULE,
  ],
  ['stock-manager']: [
    SUB_FEATURE_STOCK_MANAGER_STOCK,
    SUB_FEATURE_STOCK_MANAGER_MULTI_STORE,
  ],
};
//#endregion
